import { EmployeeGroup } from "@/Common/Api/Employee/Dto/EmployeeGroup";
import { Guid } from "@/Common/Models/Guid";
import { GroupsSearchAutocomplete } from "./GroupsSearchAutocomplete";

import styles from "./GroupSettingsComponent.module.scss";

interface GroupSettingsComponentProps {
    onDeleteGroupCallback: (groupId: Guid) => void;
    onGroupSelectCallback: (item: EmployeeGroup) => void;
    selectedGroups: EmployeeGroup[];
    editable: boolean;
    className?: string;
}

function GroupSettingsComponent(props: GroupSettingsComponentProps): JSX.Element {
    const allGroups: EmployeeGroup[] = cacheStore.EmployeeGroupCache;

    const formatedGroups = (): string => {
        if (!isArrayNullOrUndefinedOrEmpty(props.selectedGroups))
            return props.selectedGroups.map(group => group.Name).join(", ");
        return "--";
    };

    return (
        <div
            className={`${styles.groupSettingsComponent} ${props.className}`}
            data-cy="userProfile-groups"
        >
            <div className={styles.groupLabel}><label>{cacheStore.GetString("GroupsLabel")}</label></div>
            <div className={styles.groupContent}>
                {props.editable && (
                    <GroupsSearchAutocomplete
                        componentId="custom_group"
                        searchOnMount={true}
                        focusOnMount={false}
                        onItemSelectCallback={(item: EmployeeGroup) => props.onGroupSelectCallback(item)}
                        text=""
                        isValid={true}
                        groups={Immutable.List(allGroups)}
                        debounceOnTextChangeMS={400}
                    />
                )}

                {(props.editable && props.selectedGroups?.length > 0) && (props.selectedGroups.map((group: EmployeeGroup) => (
                    <div className={styles.groupItem} key={`group_${group.Id}`}>
                        <span className={styles.groupItem}>
                            <strong>{group.Name}</strong>
                        </span>
                        <span className={styles.deleteIcon} onClick={() => props.onDeleteGroupCallback(group.Id)}>X</span>
                    </div>
                )))}

                {!props.editable && (<strong>{formatedGroups()}</strong>)}
            </div>
        </div>
    );
}

export { GroupSettingsComponent };
